import { get } from 'lodash'

import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import * as Actions from '../redux/actions'
import { useClass } from '../lib/utils'

class InputText extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id      : this.props.id,
      value   : '',
      schema  : this.props.schema,
      classes : get(this.props, 'AXGClasses.input', 'form-group'),
      inputClasses: get(this.props, 'schema.classes'),
      floatingLabel : get(this.props, 'AXGOptions.floating-label', false),
      updates: get(this.props.schema, 'updates', ''),
      required: get(this.props.schema, 'required', false),
    }
  }

  // TODO: handle throttle
  handleInputChange(e) {
    let c = this
    let value = e.target.value
    c.setState({
      value: value
    })
    c.props.actions.setAppxigonState({
      key   : [c.props.AXGKey],
      value : value,
    })
    if (c.state.updates) {
      // console.log(`Update dependency for: ${c.state.updates}`)
      c.props.actions.setAppxigonState({
        key : `dependency.${c.state.updates}`,
        // make it a string. value not important, used to change a redux value to trigger update
        value: JSON.stringify(`${c.state.id}.${value}`),
      })
    }
  }

  componentWillMount() {
    var c = this
    var currentValue = get(c.props.appxigonState, c.props.AXGKey,'')
    // console.log(`input currentValue (${c.props.AXGKey}): ${currentValue}`);
    c.setState({
      value: currentValue,
    })
  }

  render() {
    // console.log(`input-text schema (${this.state.id}): ${JSON.stringify(this.state.schema)}`)
    const c = this
    var schema = c.state.schema
    var title = _t(get(schema, 'title', c.state.id))
    var icon = get(schema, 'icon', null)
    var helpMessage = get(schema, 'help-message', '')
    var id = `input-${this.state.id}`
    var isRequired = c.state.required
    var useMaterialDesign = get(schema, 'options.material-design')
    var type = c.state.id == 'password' ? 'password' : 'text'
    return (
      <div
        className={
          c.state.classes +
          (c.state.floatingLabel ? ' label-floating' : '') +
          (c.props.show ? '' : ' hidden')
        }>
        <div className={useClass(
            'input-group',
            {[`${c.state.inputClasses}`]: c.state.inputClasses}
          )
        }>
          {
            icon
            &&
            <span className="input-group-addon">
              {
                useMaterialDesign
                && <i className="material-icons">{ icon }</i>
              }
            </span>
          }
          {
            <label htmlFor={id} className='control-label'>{title}</label>
          }
            <input
              id={id}
              type={type}
              className='form-control'
              value={this.state.value}
              placeholder={this.state.floatingLabel ? '' : title}
              onChange={this.handleInputChange.bind(this)}
              data-signal={JSON.stringify(get(this.state.schema, 'signal'))}
            />
          {
            isRequired
            ? <span class="input-group-addon">*</span>
            : null
          }
          {
            helpMessage ? <p className="help-block">{ helpMessage }</p> : null
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InputText)



// WEBPACK FOOTER //
// ./item-types/input.js